const prefix = 'edit-row';
export const dataHooks = {
    editRowInput: `${prefix}-input`,
    editRowCancelButton: `${prefix}-cancel-button`,
    editRowApproveButton: `${prefix}-approve-button`,
};
//# sourceMappingURL=constants.js.map